import { type VectorLayer } from '@meitu/saas-editor-core/es/layers/vector-layer';
import { isSafari } from '@meitu/saas-editor-core/es/utils/browser-kit';
import {
    TextAlignType,
    TextVerticalAlign,
    TextWritingType,
    type IVectorLayerProps,
} from '@meitu/saas-editor-core/es/version-types';
import { TextAlignmentGroup } from '@/components/text-alignment-group';
import { useEditor } from '@/hooks/use-editor';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { type WidgetCommonProps } from '../../types';
import { Tracker } from '../../utils';

type Props = WidgetCommonProps;

export const TextAlignment: React.FC<Props> = ({ layerId, recordId }) => {
    const editor = useEditor();
    const props = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as IVectorLayerProps;
        const { textInfo } = layerData;

        if (!textInfo) return null;

        const { writingMode, textAlign, verticalAlign } = textInfo;

        return {
            writingMode,
            textAlign,
            verticalAlign,
        };
    });

    const writingMode = props ? props.writingMode : TextWritingType.HORIZONTAL_TB;
    const textAlign = (() => {
        if (isSafari && props?.textAlign === TextAlignType.JUSTIFY) return TextAlignType.LEFT; // HACK: Safari 下，隐藏 justify 选项，ui 上显示 left
        return props?.textAlign || TextAlignType.CENTER;
    })();
    const verticalAlign = props ? props.verticalAlign : TextVerticalAlign.CENTER;

    const handleChange = (kind: 'textAlign' | 'verticalAlign', value: TextAlignType | TextVerticalAlign) => {
        if (!props) return;

        if (kind === 'textAlign') {
            editor.getInstance<VectorLayer>('VectorLayer').setTextAlign(layerId, value as TextAlignType);
        } else {
            editor.getInstance<VectorLayer>('VectorLayer').setVerticalAlign(layerId, value as TextVerticalAlign);
        }

        Tracker.setAlignment({
            recordId,
            stageType: editor.services.editor.getCanvasType(),
            writingMode: TextWritingType.HORIZONTAL_TB,
            type: kind,
            value,
        });
    };

    return (
        <TextAlignmentGroup
            writingMode={writingMode}
            textAlign={textAlign}
            verticalAlign={verticalAlign}
            onChange={handleChange}
        />
    );
};
